/** Visual password strength meter for the registration form. */
import { useT } from '@/i18n/useT';
import { getPasswordStrengthLevel } from '@/features/auth/loginFormValidation';

const STRENGTH_KEYS = {
  weak: 'login.passwordStrength.weak',
  fair: 'login.passwordStrength.fair',
  strong: 'login.passwordStrength.strong',
};

const PasswordStrengthIndicator = ({ password }) => {
  const t = useT();
  const level = getPasswordStrengthLevel(password);

  if (!level) {
    return null;
  }

  return (
    <div
      className={`login-password-strength login-password-strength--${level}`}
      data-testid="password-strength"
      aria-live="polite"
    >
      <span className="login-password-strength__bar" aria-hidden="true" />
      <span className="login-password-strength__label">
        {t(STRENGTH_KEYS[level], level)}
      </span>
    </div>
  );
};

export default PasswordStrengthIndicator;
